import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AutoLayoutMode = 'full' | 'incremental' | 'off';
export type LayoutStrategy = 'left-to-right' | 'top-to-bottom' | 'hierarchical' | 'compact';

interface FlowchartLayoutState {
  autoLayoutMode: AutoLayoutMode;
  layoutStrategy: LayoutStrategy;
  setAutoLayoutMode: (mode: AutoLayoutMode) => void;
  setLayoutStrategy: (strategy: LayoutStrategy) => void;
}

type FlowchartLayoutPersistedState = Pick<FlowchartLayoutState, 'layoutStrategy'>;

export const useFlowchartLayoutStore = create<FlowchartLayoutState>()(
  persist<FlowchartLayoutState, [], [], FlowchartLayoutPersistedState>(
    (set) => ({
      autoLayoutMode: 'off',
      layoutStrategy: 'left-to-right',
      setAutoLayoutMode: (mode) => set({ autoLayoutMode: mode }),
      setLayoutStrategy: (strategy) => set({ layoutStrategy: strategy }),
    }),
    {
      name: 'flowchart-layout-settings',
      version: 1,
      partialize: (state) => ({ layoutStrategy: state.layoutStrategy }),
      migrate: (persistedState) => ({
        layoutStrategy:
          (persistedState as Partial<FlowchartLayoutPersistedState> | undefined)?.layoutStrategy ?? 'left-to-right',
      }),
    }
  )
);
